import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';

import i18n from '@/settings/i18n';
import { pages } from '@/settings/pages';
import { adminApi } from '@/services/api';
import { useFlashMessenger } from '@/hooks/useFlashMessenger';
import { useTurnstile } from '@/hooks/useTurnstile';
import { sentryReportError } from '@/utils/sentryReportError';

import { RemindForm, Values } from '../Presentation';

export const RemindFormContainer: React.FC = () => {
  const { flashError } = useFlashMessenger();
  const {
    turnstileError,
    isLoading: turnstileLoading,
    onSuccess: onTurnstileSuccess,
    onError: onTurnstileError,
    resetError: resetTurnstileError,
    createParamsWithTurnstile,
  } = useTurnstile();

  // 送信中フラグ（二重送信防止）
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (values: Values) => {
      try {
        setIsSubmitting(true);
        resetTurnstileError();

        const result = createParamsWithTurnstile(values);
        if (!result.isValid) {
          setIsSubmitting(false);
          return;
        }
        const data = result.data;

        await adminApi.sendVerificationMail({ data });
        navigate(pages.token.sent);
      } catch (err) {
        if (!axios.isAxiosError(err)) {
          return;
        }

        // 送信ボタン再活性化（再送信可能にする）
        setIsSubmitting(false);

        // 4xx, 5xx → 予期せぬエラーメッセージを表示
        sentryReportError(err);
        flashError(i18n.t('ui.error.unexpected'));
      }
    },
    [createParamsWithTurnstile, resetTurnstileError, flashError, navigate],
  );

  const childProps = {
    isDisabled: isSubmitting,
    onSubmit,
    turnstileError,
    turnstileLoading, // FormContents で ignoreTurnstile との組み合わせ判定に使用
    onTurnstileSuccess,
    onTurnstileError,
  };
  return <RemindForm {...childProps} />;
};
